import { TimePicker } from "antd";
import { getPlaceholder } from '@comps/commonFunctions';
const BaseTimePicker = (props) => {

  let format = 'hh:mm a';
  if (props.format) {
    format = props.format;
  }
  return (

    <TimePicker
      style={ {
        width: '100%',
        height: '48px',
      } }
      format={ format }
      use12Hours
      hideDisabledOptions
      { ...props }
      placeholder={ getPlaceholder(props.placeholder) }
    />

  )
}

export default BaseTimePicker